module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12M8jqr/tc-custom/9781460381151.jpg?1705766095329",
      "alt": "This image is the cover for the book Fortune for the Outlaw's Daughter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fortune for the Outlaw's Daughter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("More precious than gold "), _c('br'), _c('br'), _vm._v("Cole \"Lucky\" DuMont is off to forge his future in the Alaskan hills. Standing in his way? A dark-haired beauty in need of rescue. "), _c('br'), _c('br'), _vm._v("Maddie Stockwell's life has always been ruled by men. And now, to ensure her freedom, she strikes a deal with her gorgeous savior: she'll help Lucky in his quest, and find her own fortune along the way! Except when Maddie has to pose as Lucky's wife, she feels a thrill she could never have anticipated. And suddenly there's something even more tempting than gold on her mind")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lauri Robinson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lauri Robinson lives in Minnesota where she and her husband spend every spare moment with their three grown sons and their families—spoiling the grandchildren. She’s a member of Romance Writers of America and Northern Lights Writers. Along with volunteering for several organizations, she is a diehard Elvis and NASCAR fan. Her favorite getaway location is along the Canadian Border of Northern Minnesota on the land homesteaded by her great-grandfather.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0